module.exports = __webpack_public_path__ + "img/deluxe-vehicle-filter-welcome-background-infiniti.759b956d.png";